import FileName from './FileName'
import { FileReader, FileWriter } from '@/platform'

class AvgButton {
    public Name: string = '' //按钮的名称
    public NoneImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) //无触发事件的图片
    public MoveImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) //鼠标经过的图片
    public X: number = 0 //按钮的X坐标
    public Y: number = 0 //按钮的Y坐标

    constructor(name: string = '', noneImage: FileName = new FileName(), moveImage: FileName = new FileName(), x: number = 0, y: number = 0) {
        this.Name = name
        this.NoneImage = noneImage
        this.MoveImage = moveImage
        this.X = x
        this.Y = y
    }

    readBin(reader: FileReader) {
        this.Name = reader.readString()
        this.NoneImage = new FileName()
        this.NoneImage.readBin(reader)
        this.MoveImage = new FileName()
        this.MoveImage.readBin(reader)
        this.X = reader.readInt()
        this.Y = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.Name)
        if (this.NoneImage instanceof FileName === false) {
            this.NoneImage = Object.assign(new FileName(), this.NoneImage)
        }
        this.NoneImage.writeBin(writer)
        if (this.MoveImage instanceof FileName === false) {
            this.MoveImage = Object.assign(new FileName(), this.MoveImage)
        }
        this.MoveImage.writeBin(writer)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
    }

    readVersionedOui(reader: FileReader) {
        this.Name = reader.readString()
        this.NoneImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.MoveImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.X = reader.readInt()
        this.Y = reader.readInt()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeString(this.Name)

        if (this.NoneImage instanceof FileName === false) {
            this.NoneImage = Object.assign(new FileName(), this.NoneImage)
        }
        this.NoneImage.writeVersionedOui(writer)

        if (this.MoveImage instanceof FileName === false) {
            this.MoveImage = Object.assign(new FileName(), this.MoveImage)
        }
        this.MoveImage.writeVersionedOui(writer)

        writer.writeInt(this.X)
        writer.writeInt(this.Y)

        writer.writerLength()
    }
}

export default AvgButton
